import React from 'react'
// import { STYLES, COLORS } from 'x/config/styles'

import XIcon from './XIcon'

const ForwardIcon = (props) => <XIcon name='arrow-forward' {...props} />

export default ForwardIcon
